<template>
  <div class="container">
    <div class="inscription-flow-end">
      <h2 class="end-title">{{ $texts.titleFormEndRegistration }}</h2>
      <div class="end-generic-content">
        <div class="success">{{ $texts.registerEnd }}</div>
        <div class="registration-confirmation detail">
          <div class="image">
            <svg viewBox="0 0 39.838 48.691" width="80" height="80">
              <defs>
                <circle id="circle" cx="50" cy="50" r="50" />
                <path
                  id="shield"
                  d="M18.493,36.412,9.64,27.559l3.121-3.121,5.732,5.71L33.078,15.563,36.2,18.706M22.919,1,3,9.853V23.132C3,35.416,11.5,46.9,22.919,49.691,34.339,46.9,42.838,35.416,42.838,23.132V9.853Z"
                  transform="translate(-3 -1)"
                />
                <path
                  id="clock"
                  d="M12,20a8,8,0,1,0-8-8,8,8,0,0,0,8,8M12,2A10,10,0,1,1,2,12,10,10,0,0,1,12,2m.5,5v5.25L17,14.92l-.75,1.23L11,13V7Z"
                  transform="translate(-2, -2)"
                />

                <linearGradient
                  id="shield-gradient"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="rotate(135) translate(-25, 0)"
                >
                  <stop offset="0" stop-color="#37aba7" />
                  <stop offset="1" stop-color="#2581c4" />
                </linearGradient>
              </defs>
              <use
                xlink:href="#shield"
                fill="url(#shield-gradient)"
                transform="scale(0.8)"
              />
            </svg>
          </div>
          <div class="registration-confirmation-message">
            <div
              class="registration-validation-message highlighted-text"
              v-html="format($texts.registerRedirectMessage, targetName)"
            ></div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button class="btn btn-secondary" v-on:click="submit()">
          {{ $texts.continueButton }}
        </button>
      </div>
      <form-post-submit
        ref="formPostSubmit"
        :target="targetUrl"
        :formData="formData"
        :registrationData="registrationData"
      ></form-post-submit>
    </div>
    <footer-panel-vuetify
      :silentRefreshUrl="$appSettings.SilentRefreshUrl"
    ></footer-panel-vuetify>
  </div>
</template>

<script>
import Vue from "vue";
import { format } from "@/Commons/filters/StringFormatFilter";
import FormPostSubmit from "@/InscriptionFlow/components/hidden/FormPostSubmit.vue";
import FooterPanelVuetify from "@/Commons/components/FooterPanelVuetify.vue";

export default Vue.extend({
  name: "inscription-flow-redirect-end",

  components: { FormPostSubmit, FooterPanelVuetify },

  props: {
    targetName: {
      type: String,
      required: true
    },
    targetUrl: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    registrationData: {
      type: Object,
      required: true
    },
    isPost: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    format,

    submit() {
      if (this.isPost) {
        this.$refs.formPostSubmit.$refs.checkboxForm.submit();
      } else {
        window.location.href = this.targetUrl;
      }
    }
  },

  watch: {},

  filters: {}
});
</script>

<style scoped>
.inscription-flow-end {
  text-align: left;
}
.registration-confirmation {
  margin: 10px auto;
  padding: 15px;
}

.image {
  margin: 10px 20px 0px 20px;
}
.buttons {
  display: flex;
  margin: 10px auto;
  justify-content: space-evenly;
}
</style>

<style>
span.mail {
  font-weight: bold;
}
</style>
